export class WalletTimeoutError extends Error {
  constructor() {
    super(
      'Your wallet did not respond in time. Make sure it holds the amount to pay and enough for the network fee, then try again. If you already confirmed the transaction in your wallet, the status will update automatically once it is confirmed on-chain.'
    );
    this.name = 'WalletTimeoutError';
  }
}

export const WALLET_TIMEOUT_MS = 120_000;

// Wallet calls can hang forever — e.g. the user closes the wallet popup, or the
// wallet lacks the coin for the network fee — leaving modals stuck on "Processing…".
// Bound them so the UI always reaches a terminal state.
export const withWalletTimeout = <T>(
  promise: Promise<T>,
  ms: number = WALLET_TIMEOUT_MS
): Promise<T> => {
  let timer: ReturnType<typeof setTimeout>;

  return Promise.race([
    promise.finally(() => clearTimeout(timer)),
    new Promise<never>((_, reject) => {
      timer = setTimeout(() => reject(new WalletTimeoutError()), ms);
    }),
  ]);
};
